import { Component } from '@angular/core';
import { PrimengFileUploadComponent } from '@ntap/primeng';
import { FileSelectEvent } from 'primeng/fileupload';

@Component({
  selector: 'app-basic-file-upload',
  templateUrl: './basic-file-upload.component.html'
})
export class BasicFileUploadComponent extends PrimengFileUploadComponent {
  selectFile(select: FileSelectEvent) {
    const selectedFilesShallowCopy = [...select.files];
    this.customUploader({ files: selectedFilesShallowCopy });
    this.fileUpload.files = selectedFilesShallowCopy; // moramo postaviti da bi se i dalje vidio naziv odabranog filea u buttonu
  }
}
